export default class MinWordsValidator {

    getErrorMessage(prop) {
        return "Field should contain at least " + prop + " words";
    }

    validate(value, prop) {
        if (value === null || value === undefined) {
            return true;
        }
        if (prop === null || prop === undefined) {
            return true;
        }
        if (typeof value !== "string") {
            return true;
        }
        const trimmedValue = value.trim();
        if (!trimmedValue) {
            return true;
        }
        const words = trimmedValue.split(/\s+/).filter(Boolean);
        return words.length >= prop;
    }

}

